export const TEXTS = 'TEXTS'
export const LOADING = 'TEXTS/LOADING'
export const ERRORS = 'TEXTS/ERRORS'
export const SET_DATA = 'TEXTS/SET_DATA'
export const GET_DATA = 'TEXTS/GET_DATA'
